import { User } from '../Types/User';
import { getApiInstance } from './Api';
import { mapUser } from './UserApi';

export interface StudentInput {
  firstName: string;
  lastName: string;
  grade: number;
  email?: string;
}

export interface UpdateStudentInput extends StudentInput {
  lexileId: string;
}

export class ParentApi {
  async getStudents(): Promise<User[]> {
    const response = await getApiInstance().get(`/parent/students`);
    const users = response.data;
    console.log('Fetched students: ', users);

    return users.map(mapUser);
  }

  async createStudent(input: StudentInput): Promise<User> {
    const response = await getApiInstance().post(`/parent/students`, input);
    const user = response.data;
    console.log('Created student: ', user);

    return mapUser(user);
  }

  async updateStudent(
    studentId: string,
    input: UpdateStudentInput,
  ): Promise<User> {
    const response = await getApiInstance().put(
      `/parent/students/${studentId}`,
      input,
    );
    const user = response.data;
    console.log('Updated student: ', user);

    return mapUser(user);
  }
}
